export default function useLanguageStorage() {
  const value = localStorage.getItem('lang');
  const setLanguage = value => {
    localStorage.setItem('lang', value);
  };
  return [value, setLanguage];
}
